
import { Vue, Component } from 'vue-property-decorator';
import { Toast } from 'vant';

Vue.use(Toast);
@Component
export default class Apply extends Vue {
  copy() {
    Toast('复制成功');
  }
}
